import { authHeader } from "../../../helpers/auth-header";
import { client } from "../../../actions";
import { message } from "antd";

const getRegions = async (selectedMeterType) => {
  try {
		const { data } = await client.get(`/Meter/regions?meterTypeId=${selectedMeterType}`, {
      headers: authHeader(),
		});
    return data || [];
	} catch (e) {
		console.log(e);
		message.error("При загрузке районов произошла ошибка");
	}
}

export default getRegions;